import { MaterialReactTable } from 'material-react-table'
import { ActionButton } from '../common/CommonStyled'
import { MemberListState, useAdTeamStore } from 'src/stores/AdTeamStore'

const TableHeaderSx = {
  backgroundColor: '#30515B',
  color: 'white',
  fontSize: '14px',
  textAlign: 'center',
  '& .Mui-TableHeadCell-Content': {
    justifyContent: 'center',
    alignItems: 'center',
    display: 'flex',
    height: '100%',
  },
  '&:first-of-type': {
    borderTopLeftRadius: '5px',
    borderBottomLeftRadius: '5px',
  },
  '&:last-of-type': {
    borderTopRightRadius: '5px',
    borderBottomRightRadius: '5px',
  },
}

const TableCellSx = {
  textAlign: 'center',
  verticalAlign: 'middle',
  fontSize: '16px',
}

const ButtonStyle = {
    width:'100%',
    height:'40px'
}

interface Props{
    data:any[]
    searchText: string
}

const ExtraModalTable = ({data, searchText}:Props) => {
    const memberList = useAdTeamStore((state)=>state.memberList);
    const setField = useAdTeamStore((state)=>state.setField);
    
    const onClickAddMemberList = (rowData: MemberListState)=>{
        const update = [...memberList,rowData]
        setField('memberList',update)
    }
    
    return (
        <div style={{width:'100%'}}>
            <MaterialReactTable
                enableStickyHeader
                data={data}
                muiTableContainerProps={{
                sx: { flex: 1, overflowY: 'auto', height:'473px' }
                }}
                columns={[
                { accessorKey:'user_name', header: '이름'},
                { accessorKey:'user_id',header: '아이디'},
                { accessorKey:'phone',header:'연락처'},
                { accessorKey:'team_name',header:'소속 팀',size:100,
                    Cell: ({ cell, row }) => {
                        const value = cell.getValue<string>()
                        const rowData = row.original;
                        const isSelected = memberList.some(
                            (r) => r.uid === rowData.uid // 또는 다른 고유 필드
                            );
                        return value === '소속 없음' ? (
                            isSelected ? 
                                '추가됨'
                            :
                            <ActionButton style={ButtonStyle} onClick={()=>onClickAddMemberList(rowData)}>추가</ActionButton>
                        )
                        :
                        (value)
                     }
                },
                ]}
                // 툴바, sort 버튼 등
                enableSorting={false} // ✅ 전체 정렬 기능 제거
                enableTopToolbar={false}
                enableBottomToolbar={false}
                enableColumnActions={false}
                muiTablePaperProps={{
                elevation: 0, // ✅ 그림자 제거
                }}
                // 로우 헤더 스타일
                muiTableHeadCellProps={{
                sx: TableHeaderSx,
                }}
                // 로우 스타일
                muiTableBodyRowProps={({ row }) => ({
                    sx: {
                        cursor: 'pointer',
                        height: '49px',
                        '& > td:first-of-type': {
                        borderTopLeftRadius: '5px',
                        borderBottomLeftRadius: '5px',
                        // borderTop: row.index === selectedRowIndex ? '1px solid #229596' : 'none',
                        },
                        '& > td:last-of-type': {
                        borderTopRightRadius: '5px',
                        borderBottomRightRadius: '5px',
                        // borderRight: row.index === selectedRowIndex ? '1px solid #229596' : 'none',
                        },
                        '& > td': {
                        boxShadow: '1px 2px 2px 0 rgba(0, 0, 0, 0.1)',
                        padding: '4px',
                        // backgroundColor: row.index === selectedRowIndex ? '#E0EBEB' : '#FFF',
                        // borderTop: row.index === selectedRowIndex ? '1px solid #229596' : 'none',
                        // borderBottom: row.index === selectedRowIndex ? '1px solid #229596' : 'none',
                        },
                    },
                })}
                // 셀 스타일
                muiTableBodyCellProps={{
                sx: TableCellSx,
                }}
                // 테이블 스타일
                muiTableProps={{
                sx: {
                    borderCollapse: 'separate',
                    borderSpacing: '0 5px', // ✅ row 간격 5px
                    '& .MuiTableSortLabel-icon': {
                    color: '#aaa',
                    fontSize: '1.5rem',
                    },
                    '& .MuiTableSortLabel-root.Mui-active .MuiTableSortLabel-icon': {
                    color: 'rgb(255, 255, 255) !important',
                    },
                }}}
                // 페이지 네이션 옵션
                manualPagination 
                // 솔팅 옵션
                manualSorting
                enableSortingRemoval={false}
                // 플레이스홀더
                renderEmptyRowsFallback={() => (
                    <div style={{   height: '49px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    borderRadius: '5px',
                                    boxShadow: '1px 2px 2px 0 rgba(0, 0, 0, 0.1)',
                                    padding: '4px',
                                    color: '#999', }}>
                    {searchText ? `"${searchText}"에 해당하는 홍보관이 없습니다.`
                    :
                    '이름 또는 아이디, 연락처를 입력해 팀에 추가할 홍보관을 검색하세요.'}
                    </div>
                )}
                />
            </div>
    )
}

export default ExtraModalTable